import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import { green } from '@mui/material/colors'
import Markdown from 'react-markdown'

interface GreenTextProps {
  children: string
  variant?: 'elevation' | 'outlined'
}

export default function GreenText({ children, variant = 'elevation' }: GreenTextProps) {
  return (
    <Accordion variant={variant}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant='body1' sx={{ color: green[600], fontWeight: 500, fontStyle: 'italic' /*textDecoration: 'none'*/ }}>
          Helpful Information
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ color: green[500] }}>
        <Markdown>{children}</Markdown>
      </AccordionDetails>
    </Accordion>
  )
}
